// Drafts are scoped to the API, project and reporter. Never store credentials.
const MAX_AGE = 7 * 24 * 60 * 60 * 1000;
let database;
function open() {
  if (!database) database = new Promise((resolve, reject) => {
    const request = indexedDB.open('bugcatch-drafts', 1);
    request.onupgradeneeded = () => request.result.createObjectStore('drafts');
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
    request.onblocked = () => reject(new Error('Draft storage is blocked.'));
  }).catch((err) => { database = null; throw err; });
  return database;
}
export function draftKey(config, email) {
  return JSON.stringify([config.apiBase, config.projectId, email || config.user?.email || config.user?.id || 'anonymous']);
}
export async function draftOperation(key, value) {
  const db = await open();
  return new Promise((resolve, reject) => {
    const tx = db.transaction('drafts', value === undefined ? 'readonly' : 'readwrite');
    const store = tx.objectStore('drafts');
    const request = value === undefined ? store.get(key) : value === null ? store.delete(key) : store.put({ ...value, savedAt: Date.now() }, key);
    tx.oncomplete = () => resolve(request.result);
    tx.onerror = () => reject(tx.error);
    tx.onabort = () => reject(tx.error || new Error('Draft was not saved.'));
  });
}
export async function readDraft(key) {
  const value = await draftOperation(key);
  if (value && Date.now() - value.savedAt > MAX_AGE) { await draftOperation(key, null); return null; }
  return value || null;
}
